import { render } from "./TablePaymentButton.vue?vue&type=template&id=6e8c1b02"
import script from "./TablePaymentButton.vue?vue&type=script&lang=js"
export * from "./TablePaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__